export const TOAST_MESSAGE = 'TOAST_MESSAGE';
export const DEAL_MESSAGE = 'DEAL_MESSAGE';
export const UNEXPECTED_ERROR = 'UNEXPECTED_ERROR';
export const SYSTEM_ERROR = 'SYSTEM_ERROR';
export const DEAL_ERROR = 'DEAL_ERROR';
export const PROCESS = 'PROCESS';
export const LANGUAGE = 'LANGUAGE';
